<template>
  <div>
    <div class="bottom">
      <div class="bottomContent">
        <div>
          <div class="neir">
            <div @click="goDetil(item)"
                 class="fo"
                 style="display: flex;"
                 v-for="item in this.$store.state.m_user.aboutList"
                 :key="item.ID">
              <div>
                <!-- {{ item.TITLE }} -->
              </div>
              <span style="margin: 0 8px;">|</span>
            </div>

          </div>

          <!-- <div class="nd">
            联系方式:客服电话400 998 4569（ 周一至周五8:30-12:00/14:00-17:30）
          </div>
          <div class="nd">
            客服QQ: 3550339480
          </div>
          <div class="nd">
            客服QQ群: 458367595
          </div>
          <div class="nd">
            客服邮箱: zhangjuan@gc80.cn
          </div> -->
          <div v-if="this.$store.state.m_user.bottomValue">
            <div v-html="this.$store.state.m_user.bottomValue.PIC_DESC">

            </div>
            <a href="https://www.sobot.com/chat/pc/index.html?sysNum=ab2e331f1c2d41c4878fa99631b6f703"
               target="_blank">
              <div class="btn">
                <img src="@/assets/images/zxkf.png"
                     alt="">
                <span>在线客服</span>
              </div>
            </a>
          </div>
        </div>

        <div class="nav-list">
          <div class="nav-item">
            <p>关于我们</p>
            <div style="margin-bottom: 10px;">
              <div @click="openWe"
                   style=" color:  #bdbcbc;">关于我们</div>
            </div>

          </div>
          <div class="nav-item">
            <p>法律条款</p>
            <div style="margin-bottom: 10px;">
              <div @click="openYs"
                   style=" color:  #bdbcbc;">隐私协议</div>
              <!-- <a  href="#section2" target="_blank">用户注册协议</a> -->
              <!-- <router-link :to="{path:'/ys'}">隐私协议</router-link> -->
            </div>
            <div>
              <div @click="openXy"
                   style=" color:  #bdbcbc;">用户注册协议</div>

              <!-- <a  href="#section2" target="_blank">用户注册协议</a> -->
              <!-- <a href="https://api.nmgrcw.com/content/single/1/41/content" target="_blank">用户注册协议</a> -->
            </div>
          </div>
          <div class="nav-item">
            <p>友情链接</p>
            <div style="margin-bottom: 10px;">
              <a href="https://www.mohrss.gov.cn/"
                 target="_blank">中华人民共和国人社部</a>
            </div>
            <div style="margin-bottom: 10px;">
              <a href="https://rst.nmg.gov.cn/"
                 target="_blank">内蒙古自治区人力资源和社会保障厅</a>
            </div>
            <div style="margin-bottom: 10px;">
              <a href="http://rsj.huhhot.gov.cn/?ivk_sa=1024320u"
                 target="_blank">呼和浩特市人力资源和社会保障局</a>
            </div>
            <div style="margin-bottom: 10px;">
              <a href="http://www.hhpta.org.cn/"
                 target="_blank">呼和浩特市人事考试信息网</a>
            </div>
            <div style="margin-bottom: 10px;">
              <a href="https://www.nmgrck.cn/front/index"
                 target="_blank">内蒙古人才信息库（打印审验卡）</a>
            </div>

          </div>
        </div>

        <div>
          <div class="tu"
               v-if="this.$store.state.m_user.gzhEwm">
            <img :src="this.$store.state.m_user.gzhEwm.PIC_URL"
                 :alt="this.$store.state.m_user.gzhEwm.PIC_TITLE">
            <div style="text-align: center;width: 150px;">
              {{ this.$store.state.m_user.gzhEwm.PIC_TITLE }}
            </div>
          </div>
        </div>
      </div>

    </div>
    <div class="tio"
         v-if="this.$store.state.m_user.beiAn">
      <a href="https://beian.miit.gov.cn/"
         target="_blank"
         v-html="this.$store.state.m_user.beiAn.PIC_DESC">

      </a>
    </div>
  </div>
</template>
<script>
// 这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
// 例如：import 《组件名称》 from '《组件路径》';

export default {
  // import引入的组件需要注入到对象中才能使用
  components: {},
  data() {
    // 这里存放数据
    return {};
  },
  // 监听属性 类似于data概念
  computed: {},
  // 监控data中的数据变化
  watch: {},
  // 方法集合
  methods: {
    openYs() {
      this.$router.push({
        path: '/ys'
      });
    },
    openWe() {
      this.$router.push({
        path: '/we'
      });
    },
    openXy() {
      this.$router.push({
        path: '/xy'
      });
    }
  },
  // 生命周期 - 创建完成（可以访问当前this实例）
  created() {},
  // 生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {},
  beforeCreate() {}, // 生命周期 - 创建之前
  beforeMount() {} // 生命周期 - 挂载之前
};
</script>
<style lang="less">
/* //@import url(); 引入公共css类 */
a {
  color: #fff;
  text-decoration: none;
}
a {
  font-size: 14px;
  color: #bdbcbc;
}
.btn {
  margin-top: 20px;
  width: 100px;
  height: 30px;
  color: #fff;
  border-radius: 10px;
  background-color: #2c5dff;
  display: flex;
  justify-content: center;
  align-items: center;
  img {
    padding-right: 5px;
  }
}
.bottom {
  font-family: Regular;
  width: 100%;
  height: 289px;
  display: flex;
  justify-content: center;
  padding-top: 40px;
  background: #474747;
  .bottomContent {
    width: 1200px;
    color: #fff;
    font-size: 14px;
    display: flex;
    justify-content: space-between;
    .neir {
      color: #fff;
      display: flex;
      cursor: pointer;
      .fo:last-child {
        span {
          display: none;
        }
      }
    }
    .nd {
      margin: 15px 0;
    }
    .tu {
      img {
        width: 150px;
        height: 150px;
      }
    }
    .nav-list {
      width: 500px;
      display: flex;
      justify-content: space-between;
    }
  }
}
.tio {
  height: 50px;
  line-height: 50px;
  text-align: center;
  width: 100%;
  background: #333;
  color: #fff;
  font-size: 14px;
  .footer-section2 {
    margin: 0;
  }
}
</style>